import React from "react";
import { Typography, Box } from "@mui/material";
import Header from '../header/header';
import Footer from '../commun/Footer';
import SidebarFichesMetiers from "../commun/SidebarFichesMetiers";
import "./Cgu.css";

const FicheExpertMachineLearning = () => (
  <>
    <Header />
    <div className="fiche-layout">
      <Box className="fiche-main" component="section">
        <Typography variant="h5" gutterBottom>
          🧩 Recruter un Expert en Machine Learning
        </Typography>
        <Typography variant="h6" gutterBottom>
          Description du poste
        </Typography>
        <Typography paragraph>
          L’Expert en Machine Learning conçoit, entraîne et optimise des algorithmes capables d’apprendre à partir des données. Il intervient sur des projets complexes où l’automatisation intelligente et la précision des prédictions sont clés : moteurs de recommandation, maintenance prédictive, scoring client, détection de fraude, etc. Il combine une forte maîtrise des modèles mathématiques avec une approche opérationnelle orientée production.
        </Typography>
        <Typography variant="h6" gutterBottom>
          Missions principales
        </Typography>
        <ul className="cgu-list">
          <li>Sélectionner et implémenter les modèles de machine learning adaptés</li>
          <li>Prétraiter les données et définir les features les plus pertinentes</li>
          <li>Optimiser les hyperparamètres et évaluer les performances des modèles</li>
          <li>Industrialiser les modèles (via des API, conteneurs, pipelines MLOps)</li>
          <li>Participer à la conception de plateformes d’apprentissage automatique à l’échelle</li>
          <li>Accompagner les équipes produit et data dans l’intégration des modèles</li>
        </ul>
        <Typography variant="h6" gutterBottom>
          Compétences clés
        </Typography>
        <ul className="cgu-list">
          <li>Python (Scikit-learn, XGBoost, LightGBM), R</li>
          <li>Connaissance approfondie des techniques : régression, arbres, réseaux de neurones</li>
          <li>Pratique avancée du MLOps (MLflow, Airflow, Docker, Kubernetes)</li>
          <li>Cloud (AWS SageMaker, Google Vertex AI, Azure ML)</li>
          <li>Culture data et excellence en mathématiques appliquées</li>
        </ul>
        <Typography variant="h6" gutterBottom>
          Profils recherchés / Niveaux d’expérience
        </Typography>
        <ul className="cgu-list">
          <li>Confirmé : expérience de plusieurs projets ML en production</li>
          <li>Expert : forte autonomie, capacité à proposer des modèles innovants, à encadrer ou auditer</li>
          <li>Spécialiste secteur : finance, santé, e-commerce, manufacturing…</li>
        </ul>
        <Typography variant="h6" gutterBottom>
          Tarifs / TJM indicatifs
        </Typography>
        <ul className="cgu-list">
          <li>Confirmé : 500–700 € / jour</li>
          <li>Expert : 750–1 100 € / jour, selon la complexité des projets et l’environnement technique</li>
        </ul>
      </Box>
      <Box className="fiche-sidebar" component="aside">
        <SidebarFichesMetiers />
      </Box>
    </div>
    <Footer />
  </>
);

export default FicheExpertMachineLearning;
